// import { Button } from './ui/button'
import { cn } from '@/lib/utils'
import { Dialog, DialogClose, DialogContent, DialogTrigger } from './ui/dialog'
import { DetailedHTMLProps, ImgHTMLAttributes } from 'react'
import { Button } from './ui/button'
import { X } from 'lucide-react'

export default function ZoomableImage({
  src,
  alt,
  className,
}: DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
  if (!src) return null
  return (
    <Dialog>
      <DialogTrigger asChild>
        <img
          src={src}
          alt={alt || ''}
          sizes="100vw"
          className={cn("cursor-pointer", className)}
          style={{
            width: '100%',
            height: 'auto',
          }}
          width={500}
          height={100}
        />
      </DialogTrigger>
      <DialogContent className="max-w-7xl border-0 bg-transparent p-0 shadow-none" closeClassName="hidden">
        <div className="relative w-full overflow-clip flex rounded-md bg-transparent max-h-[80vh] items-center justify-center">
          <DialogClose asChild>
            <Button variant="ghost" className="absolute top-2 right-2 text-white">
              <X className="size-4" />
            </Button>
          </DialogClose>
          <img src={src} alt={alt || ''} className="max-h-full max-w-full object-contain" />
        </div>
      </DialogContent>
    </Dialog>
  )
}
